import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function unResolvedBannerReducer(state = initialState.unResolvedBannerStatus, action) {
  switch (action.type) {
    case types.SET_UNRESOLVED_BANNER_STATUS:
      return {
        ...state,
        unResolvedBannerStatus: action.unResolvedBannerStatus,
      };
    default:
      return state;
  }
}
